import { useState } from "react";
import { useFetch } from "@/hooks/useFetch";
import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PublicLayout";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export default function Gallery() {
  const { data } = useFetch("/gallery");
  const [open, setOpen] = useState(null);
  return (
    <>
      <Seo title="Galeri" description="Masal Sanat Akademi derslerinden, atölyelerden ve konserlerden kareler." />
      <PageHero eyebrow="Galeri" title="Akademiden kareler" />
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 columns-1 sm:columns-2 lg:columns-3 gap-5 [&>*]:mb-5" data-testid="gallery-grid">
        {(data || []).map((g, i) => (
          <button key={g.id} onClick={() => setOpen(g)} data-testid={`gallery-item-${i}`}
            className="group block w-full overflow-hidden rounded-3xl break-inside-avoid relative">
            <img src={g.image_url} alt={g.caption || "Galeri görseli"} loading="lazy" className="w-full object-cover transition-transform duration-700 group-hover:scale-105" />
            {g.caption && <span className="absolute inset-x-3 bottom-3 rounded-full bg-white/90 backdrop-blur px-4 py-1.5 text-sm font-bold text-navy text-left">{g.caption}</span>}
          </button>
        ))}
      </section>
      <Dialog open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent className="max-w-4xl p-2 rounded-3xl" data-testid="gallery-lightbox">
          <DialogTitle className="sr-only">{open?.caption || "Görsel"}</DialogTitle>
          {open && <img src={open.image_url} alt={open.caption} className="w-full rounded-2xl" />}
          {open?.caption && <p className="px-3 pb-2 font-bold text-navy">{open.caption}</p>}
        </DialogContent>
      </Dialog>
    </>
  );
}
